export default {
    namespaced: true,

    state: {
        isSign: false,
        userInfo: {
            name: '',
            userId: '',
            maskFlag: '',
            partnerAuthGroupId:'',
            viewYN: '',
            modYn: '',
            mngNotice: '',
        },
        token: "",
        refreshToken: "",
        signedDate: null,
        menuPermission: []
    },
    getters: {
        getSign(state) {
            return state.isSign
        },
        getSignedDate(state) {
            return state.signedDate
        }
    },
    mutations: {
        setSignIn(state) {
            state.isSign = true
            state.signedDate = new Date()
            console.log("setSignIn:" + state.signedDate)
        },
        setSignOut(state) {
            state.isSign = false
            state.signedDate = null
        },
        setUserInfo(state, value){
            for (const key in state.userInfo) {
                state.userInfo[key] = value[key];
            }
        },
        setToken(state, value){
            state.token = value
        },
        setRefreshToken(state, value){
            state.refreshToken = value
        },
        setSignedDate(state, value){
            state.signedDate = value
            console.log("setSignedDate:" + state.signedDate)
        },
        setMenuPermission(state, value){
            state.menuPermission = value
        }
    },
    actions: {

    },
}
